<template>
	<div>
		<div class="space-y-2">
			<div class="grid grid-cols-3">
				<h4 class="text-sm text-gray-900">{{ __("Article") }}</h4>
				<p class="col-span-2 text-sm">
					<!-- {{ __(tradeLabel) }}<br> -->
					{{ __(productLabelLight) }}
					<br />
					{{ __(originLabel) }}
					<br />
					{{ __("Harvest") }}
					{{ offer.product.harvest || __("n.a.") }}
				</p>
			</div>
		</div>

		<!-- Quality -->
		<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
			<h4 class="text-sm text-gray-900">{{ __("Quality") }}</h4>
			<p class="col-span-2 text-sm">
				<crop-quality-summary :tradable="offer" />
			</p>
		</div>

		<!-- Fulfilment Date -->
		<div
			v-if="offer.date.type != null"
			class="grid grid-cols-3 border-t border-gray-200 pt-2"
		>
			<h4 class="text-sm text-gray-900">
				{{ __("Fulfilment Date") }}
			</h4>
			<p class="text-sm col-span-2">
				{{ options.dateToString(offer, locale) }}
				<span
					v-html="maybeStrikethrough(null, options.dateToString(offer, locale))"
				/>
			</p>
		</div>

		<!-- Location -->
		<div
			v-if="options.locationToString(offer) != ''"
			class="grid grid-cols-3 border-t border-gray-200 pt-2"
		>
			<h4 class="text-sm text-gray-900">{{ __("Location") }}</h4>
			<p class="text-sm col-span-2">
				{{
					$cropOptions.getLocalizedLabel(
						offer.location.mode,
						$cropOptions.locationModeOptions
					)
				}}
				<span
					v-if="offer.location.optional_transport"
					:class="[!offer.visible ? 'text-gray-300' : 'text-gray-500']"
					>({{ __("Transportation possible") }})</span
				>
				<br />
				{{ offer.location.address.zip }}
				{{ offer.location.address.city }}
			</p>
		</div>

		<!-- Contract conditions -->

		<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
			<h4 class="text-sm text-gray-900 hyphens">
				{{ __("Contract Conditions") }}
			</h4>
			<p
				class="text-sm col-span-2"
				v-if="offer.extra.contract != null && offer.extra.contract != ''"
			>
				<span v-html="contractTerms" />
			</p>
			<p class="text-sm col-span-2" v-else>
				{{ __("Einheitsbedingungen in Anlehnung an Aufkaufbedingungen") }}
			</p>
		</div>

		<!-- Payment conditions -->
		<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
			<h4 class="text-sm text-gray-900 hyphens">
				{{ __("Payment Conditions") }}
			</h4>
			<p
				class="text-sm col-span-2"
				v-if="
					offer.extra.payment_terms != null && offer.extra.payment_terms != ''
				"
			>
				{{
					__(
						options.getLabel(
							offer.extra.payment_terms,
							options.paymentTermsOptions
						)
					) || __("not provided")
				}}
				<!-- :-( -->
				<span
					v-html="
						maybeStrikethrough(
							__(options.getLabel(null, options.paymentTermsOptions)),
							__(
								options.getLabel(
									offer.extra.payment_terms,
									options.paymentTermsOptions
								)
							)
						)
					"
				/>
			</p>
			<p class="text-sm col-span-2" v-else>
				{{ __("Netto Kasse gegen Liefernachweis") }}
			</p>
		</div>

		<!-- Payment method -->
		<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
			<h4 class="text-sm text-gray-900">
				{{ __("Payment Method") }}
			</h4>

			<p
				class="text-sm col-span-2"
				v-if="
					offer.extra.payment_mode != null && offer.extra.payment_mode != ''
				"
			>
				{{
					__(
						options.getLabel(
							offer.extra.payment_mode,
							options.paymentModeOptions
						)
					) || __("not provided")
				}}
				<span
					v-html="
						maybeStrikethrough(
							__(options.getLabel(null, options.paymentModeOptions)),
							__(
								options.getLabel(
									offer.extra.payment_mode,
									options.paymentModeOptions
								)
							)
						)
					"
				/>
			</p>
			<p class="text-sm col-span-2" v-else>
				{{ __("Gutschrift") }}
			</p>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions.js");
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			options: options,
		};
	},
	mounted() {},
	computed: {
		productLabel() {
			return (
				this.offer.product.origin +
				" " +
				this.__(
					this.getLabel(
						this.offer.product.grade,
						this.options.productGradeOptions
					) ||
						this.getLabel(
							this.offer.product.type,
							this.options.productTypeOptions
						)
				)
			);
		},
		productLabelLight() {
			return this.__(
				this.getLabel(
					this.offer.product.grade,
					this.options.productGradeOptions
				) ||
					this.getLabel(
						this.offer.product.type,
						this.options.productTypeOptions
					)
			);
		},
		originLabel() {
			return this.__(
				this.getLabel(this.offer.product.origin, this.options.originOptions) ||
					this.getLabel(this.offer.product.origin, this.options.originOptions)
			);
		},
		contractTerms() {
			return this.contractToString(this.offer);
		},
		/*referenceTerms() {
			return this.contractToString(this.reference);
		},*/
		qualityIsEmpty() {
			let isEmpty = !Object.values(this.offer.quality).some(
				(x) => x !== null && x !== ""
			);
			return isEmpty;
		},
		showRapeExtra() {
			return (
				this.offer.product.type == "RAPE" &&
				!(this.offer.type == "BID" && this.offer.trade == "SELL")
			);
		},
	},
	methods: {
		getLabel(what, where) {
			return options.getLabel(what, where);
		},
		maybeStrikethrough(ref, now, suffix = "") {
			if (ref == null || ref == "") {
				return "";
			} else if (ref == now) {
				return "";
			} else {
				return `<span class="line-through text-red-600">${ref} ${suffix}</span>`;
			}
		},
		contractToString(tradable) {
			if (!tradable) {
				return "";
			} else if (tradable.extra.contract == "EHB") {
				return this.__("Standard conditions");
			} else if (tradable.extra.contract == "EHB_CUSTOM") {
				return this.__(`Standard conditions based on buy-out conditions`);
			} else {
				return this.__("not provided");
			}
		},
	},
};
</script>
